import type { StepProps } from '@/types/apply'

const PLATFORMS = [
  { key: 'instagram' as const, label: 'Instagram', placeholder: 'https://instagram.com/youraccount' },
  { key: 'tiktok' as const, label: 'TikTok', placeholder: 'https://tiktok.com/@youraccount' },
  { key: 'twitter' as const, label: 'X (Twitter)', placeholder: 'https://x.com/youraccount' },
  { key: 'facebook' as const, label: 'Facebook', placeholder: 'https://facebook.com/youraccount' }
]

export default function StepSocial({ formData, updateField, errors, clearError }: StepProps) {
  const s = formData.social_media

  return (
    <div className="space-y-5">
      <p className="text-sm text-white/50">
        At least one social media link is required so we can verify your identity.
      </p>

      {errors.social_media && <p className="apply-error-text">{errors.social_media}</p>}

      {PLATFORMS.map(platform => (
        <div key={platform.key}>
          <label className="apply-label">{platform.label}</label>
          <input
            type="url"
            className="apply-input"
            placeholder={platform.placeholder}
            value={s[platform.key]}
            onChange={e => {
              updateField('social_media', platform.key, e.target.value)
              clearError('social_media')
            }}
          />
        </div>
      ))}
    </div>
  )
}
